<template>
  <div class="container">
    <div class="theme">
      <img src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20250919160954875.png" />
    </div>
    <div class="themeTwo">
      <img src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20250923115934179.png" />
    </div>
    <div class="lottery-box">
      <img src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20250919154714193.png" />
      <div class="scroll-cont">
        <div class="lucky-box">
          <img src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20250923100633384.png" />
          <div class="swappe-cont" :style="`transform: translateX(-${scrollLeft}px);`">
            <div class="lucky-gift" v-for="(item,index) in prizeList" :key="index">
              <!-- <img v-if="item.state === 1" src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20211209134956815.png" />
              <img v-else src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20211213100936900.png" /> -->
              <img :src="goodsList[item.state].bigUrl" />
            </div>
          </div>
          <div class="over-mask" v-show="!luckyResult">
            <img src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20211209140928950.png" />
          </div>
          <div class="cover-area">
            <img src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20250919154806822.png" />
          </div>
        </div>
        <div class="last-count">
          <div class="con-txt">剩余<span>{{ luckNums }}</span>次抽奖机会</div>
        </div>
      </div>
      <div class="operate">
        <!-- <van-button type="default" @click="handleClick(2)">增加次数
          <i class="icon-solid-right" />
        </van-button> -->
        <van-button type="default" @click="drawLottery()">立即抽奖</van-button>
      </div>
      <div class="my-record" @click="handleClick(1)">
        我的中奖记录 <i class="icon-solid-right" />
      </div>
    </div>
    <!-- <scroll-list :record-list="recordList" :line-height="30" time-color="#666666" main-color="#000000" light-color="#e00000" bg-color="#f2fcab" shadow-color="#008f37" v-if="recordList.length > 0" /> -->
    <div class="koi-prize" v-if="1==2">
      <div class="koi-title">
        <img src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20211209170410678.png" />
      </div>
      <div class="prize-cont">
        <div class="gift">
          <img src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20211209134956815.png" />
        </div>
        <div class="name">蔓薇LAX系列（西梅）<span class="big">价值</span>
          <span>￥</span><span class="big">260</span>
        </div>
      </div>
    </div>
    <div class="rule-cont">
      <div class="rule-title">
        <img src="http://freesaasofficedata.oss.aliyuncs.com/miShop/20250923100543161.png" />
      </div>
      <div class="rule-list">
        <div class="rule-item">
          <span class="num">1</span>
          活动期间单个美妆订单实付金额满1000元可获得1次抽奖次数，不足1000元则不计入；
          <p>例：订单实付金额3899元，可获得抽奖次数3次；</p>
        </div>
        <div class="rule-item">
          <span class="num">2</span>
          订单完成支付后即可抽奖，奖品将随对应订单一并发货；
        </div>
        <div class="rule-item">
          <span class="num">3</span>
          <p class="red-txt">因抽奖过程中可能遇到的网络故障等相关问题，导致抽奖页面显示的奖品与实际中奖结果不一致时，以订单详情显示的奖品名称为准。</p>
        </div>
      </div>
    </div>
    <!-- 中奖弹窗 -->
    <lucky-pup v-if="showPopupLayer" @bindtap="handleClick" :lucky-data="luckyResult" />
  </div>
</template>

<script>
import LuckyPup from './components/LuckyPup';
import ScrollList from './components/ScrollList';
import { randomNum } from '../../utils/public'
import { Subtr } from "../../utils/handle"
import { deliveryMessage, replaceAppToken } from "../../utils/appUtil";
let interval = null;
export default {
  components: { ScrollList, LuckyPup },
  name: 'SlotMachine',
  data() {
    return {
      luckNums: 0,
      prizeList: [],
      scrollLeft: 0,
      luckyResult: null,
      recordList: [],// 所有人的中奖记录
      showPopupLayer: false,
      isInApp: false,
      isLottery: false, //是否正在抽奖
      goodsList: [],  //奖品列表
    }
  },
  created() {
    let { token } = this.$route.query;
    if (token) {
      this.isInApp = true;
      return replaceAppToken(token, () => {
        this.initFun();
      })
    }
    this.initFun();
  },
  methods: {
    initFun() {

      this.getRecordList();
      this.getMWActTime();
      this.getGoodsList();
    },
    // 通过接口获取奖品列表
    getGoodsList() {
      this.get('/OrderGoods/Activity/GetRyActivityPrizeList', { activityType: 1001 }, 2).then(res => {
        if (res.code == 1) {
          this.goodsList = res.response;
          this.initPrizeList();
        }
      })
    },
    //初始化奖品列表
    initPrizeList() {
      // let list = [{ state: 0 }, { state: 1 }];
      // for (let i = 0; i < 10; i++) {
      //   list.push({ state: 0 })
      //   list.push({ state: randomNum(0, this.goodsList.length-1) });
      //   list.push({ state: 1 })
      // }
      // list.push({ state: 0 });
      // list.push({ state: 1 });
      // console.log(list,'111');
      // this.prizeList = list;

      let prizeArray = [1, 0, 2];
      let num = 20;
      for (var i = 0; i < num + 3; i++) {
        if (i < 3) {
          prizeArray.push(Math.floor(Math.random() * (this.goodsList.length - 1) + 1))
        } else if (i >= 2 && i < 20) {
          prizeArray.push(Math.floor(Math.random() * this.goodsList.length))
        } else {
          prizeArray.push(prizeArray[i - num])
        }
      }
      const prizeArrayObj = prizeArray.map((name) => {
        return {
          state: name
        };
      });
      console.log(prizeArrayObj,'prizeArrayObj')
      this.prizeList = prizeArrayObj;
    },
    getRecordList() {
      this.get('/OrderGoods/Activity/GetGeneralprizeList', { isAll: 1 }, 2).then(res => {
        if (res.code === 1) {
          this.recordList = res.response || [];
        }
      })
    },
    //获取双12蔓薇活动时间
    getMWActTime() {
      this.get("/OrderGoods/Activity/GetHoursAndNums", { temp: +new Date(), v: 2 }, 2).then(json => {
        if (json.code === 1) {
          let { luckNums } = json.response;
          this.luckNums = luckNums;
        }
      })
    },
    //抽奖
    drawLottery() {
      if (this.isLottery) return;
      if (this.luckNums <= 0) {
        this.luckyResult = { type: 0 }
        this.showPopupLayer = true;
        return;
      }
      this.isLottery = true;
      this.luckyResult = null;
      let end = false, scrollLeft = 0, speed = 50, duration = 0;
      let len = this.prizeList.length - 2;
      let maxLen = (len - 2) * 120;
      let luckyResult = null; //中奖结果
      if (interval) clearInterval(interval);
      interval = setInterval(() => {
        if (end) {
          if (speed <= 30) {
            if (speed === 30) {
              let num = Math.floor(scrollLeft / 120);
              duration = 360 - (scrollLeft - num * 120);
              let targetNum = num + 5;
              console.log(targetNum, len)
              if (targetNum > len) targetNum = targetNum - len + 2;
              console.log(targetNum, len)
              this.goodsList.forEach((it, index) => { 
                if (it.id == luckyResult.prizeId) {
                  this.prizeList[targetNum - 1].state = index;
                }
              })
              // if (luckyResult.type === 2) {
              //   this.prizeList[targetNum - 1].state = 1;
              // } else {
              //   this.prizeList[targetNum - 1].state = 0;
              //   this.prizeList[targetNum].state = 1;
              // }
            }
            if (duration > 0) {
              speed = duration / 12;
              speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
              duration -= speed;
            } else {
              speed = 0;
            }
          } else {
            speed -= 5;
          }
          if (speed <= 0) {
            this.isLottery = false;
            clearInterval(interval);
            this.luckyResult = luckyResult;
            this.showPopupLayer = true;
          }
        }
        if (scrollLeft > maxLen) {
          console.log('阻断滚动', scrollLeft, maxLen)
          scrollLeft = scrollLeft - maxLen;
        }
        scrollLeft = Subtr(scrollLeft, -speed);
        this.scrollLeft = scrollLeft;
      }, 100);
      this.get("/OrderGoods/Activity/GetTakeGeneralprize", {v:2}, 2).then(res => {
        if (res.code === 1) {
          this.luckNums = this.luckNums - 1;
          let { prize, showType } = res.response;
          prize.type = showType;
          luckyResult = prize;
          setTimeout(() => { end = true; }, 2000);
        } else {
          end = true;
          clearInterval(interval);
          this.scrollLeft = 0;
          this.isLottery = false;
          this.$toast(res.msg);
        }
      })
    },
    //弹窗点击事件
    handleClick(e) {
      //0关闭弹窗 1查看记录 2采购订货
      this.showPopupLayer = false;
      if (e === 1) this.$router.push(`/lottery/slotRecord?`);
      else if (e === 2) {
        if (this.isInApp) {
          deliveryMessage({ 'action': 'jumpShopkeeperOrder', 'good': '4' })
        } else {
          window.location.href = this.baseHost + '/7999/Arongleweb/html/groupon/groupon_list.html?brandId=4';
        }
      } else {
        this.scrollLeft = 0;
        this.luckyResult = null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  background: url('http://freesaasofficedata.oss.aliyuncs.com/miShop/20250923100438383.jpg')
    no-repeat;
  background-size: 100% auto;
  .theme {
    text-align: center;
    img {
      width: 100%;
    }
  }
  .themeTwo {
    text-align: center;
    padding: 0 30px;
    img {
      width: 100%;
    }
  }
  .lottery-box {
    position: relative;
    padding: 50px 0 10px;
    > img {
      max-width: 100%;
    }
    .scroll-cont {
      position: absolute;
      top: 2px;
      left: 30px;
      right: 30px;
      .lucky-box {
        padding: 30px 20px;
        position: relative;
        overflow: hidden;
        box-sizing: border-box;
        img {
          width: 100%;
        }
        .swappe-cont {
          position: absolute;
          top: -3px;
          left: calc(50% - 160px);
          width: 240px;
          bottom: 0;
          z-index: 10;
          display: flex;
          animation: 0.1s linear;
          align-items: center;
          .lucky-gift {
            width: 80px;
            height: 80px;
            // padding: 5px;
            flex-shrink: 0;
            box-sizing: border-box;
            margin-right: 40px;
            border-radius: 10px;
            // box-shadow: 0 5px 0 #6e8201;
            // background: linear-gradient(to bottom, #89c6ff, #89c6ff);
            // background: -webkit-linear-gradient(to bottom, #89c6ff, #89c6ff);
            // background: -o-linear-gradient(to bottom, #89c6ff, #89c6ff);
            // background: -moz-linear-gradient(to bottom, #89c6ff, #89c6ff);
            img {
              border-radius: 10px;
              background-color: #fff;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .over-mask,
        .cover-area {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .over-mask {
          top: 20px;
          left: 20px;
          right: 20px;
          bottom: 20px;
          z-index: 20;
          display: none;
        }
        .cover-area {
          left: -10px;
          right: -10px;
          z-index: 30;
        }
      }
      .last-count {
        text-align: center;
        position: relative;
        .con-txt {
          color: #fff;
          padding: 2px 10px;
          display: inline-block;
          position: relative;
          z-index: 10;
          border-radius: 20px;
          letter-spacing: 1px;
          background-color: #f87fbb;
          span {
            color: #fbe671;
          }
        }
        &:before {
          content: '';
          position: absolute;
          left: 20%;
          bottom: 10px;
          width: 60%;
          height: 1px;
          z-index: 1;
          background-color: #f87fbb;
        }
      }
    }
    .operate {
      position: absolute;
      left: 14%;
      right: 14%;
      bottom: 19.5%;
      text-align: center;
      .van-button {
        border: none;
        height: 32px;
        width: 128px;
        background: url('http://freesaasofficedata.oss.aliyuncs.com/miShop/20250919154911472.png')
          no-repeat;
        background-size: 100% 100%;
        .van-button__text {
          color: #fff;
          .icon-solid-right {
            display: inline-block;
            vertical-align: middle;
          }
        }
        &:active:before {
          background: none;
        }
      }
    }
    .my-record {
      position: absolute;
      left: 20%;
      right: 20%;
      bottom: 10%;
      color: #f87fbb;
      font-size: 14px;
      text-align: center;
      .icon-solid-right {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  .koi-prize {
    padding: 0 20px 10px;
    text-align: center;
    .koi-title {
      text-align: center;
      padding-bottom: 10px;
      img {
        width: 185px;
      }
    }
    .prize-cont {
      padding: 6px;
      border-radius: 6px;
      box-sizing: border-box;
      background-color: #008f37;
      .gift {
        border-radius: 6px;
        box-sizing: border-box;
        border: 1px solid #c1e801;
        background-color: #f9ffce;
        img {
          max-width: 60%;
          max-height: 90px;
        }
      }
      .name {
        padding: 5px 0;
        color: #000000;
        font-size: 18px;
        span {
          font-size: 13px;
        }
        .big {
          font-size: 22px;
        }
      }
    }
  }
  .rule-cont {
    padding: 50px 22px;
    position: relative;
    // background: url('http://freesaasofficedata.oss.aliyuncs.com/miShop/20211209170729590.png')
    //   no-repeat left bottom;
    // background-size: 100% auto;
    .rule-title {
      position: absolute;
      top: 33px;
      z-index: 10;
      left: calc(50% - 79px);
      img {
        width: 158px;
      }
    }
    .rule-list {
      padding: 40px 20px;
      border: 2px solid #89c6ff;
      border-radius: 10px;
      .rule-item {
        color: #000;
        line-height: 20px;
        position: relative;
        padding-left: 20px;
        margin-bottom: 5px;
        .num {
          position: absolute;
          top: 0;
          left: 0;
          width: 15px;
          height: 15px;
          color: #fff;
          border-radius: 50%;
          line-height: 15px;
          text-align: center;
          background-color: #89c6ff;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
.red-txt{
  color: #cc1111;
}
</style>